<div class="ideals-chips">
  <ideals-input-control-wrapper #wrapper=wrapper
                                [id]="id"
                                [errorList]="errorList"
                                [errorsToShow]="errorsToShow"
                                [canShowError]="canShowError">
    <div class="ideals-input-element"
         [formGroup]="formControl"
         data-ideals="addEmailsContainer">
      <ideals-chip *ngFor="let control of formControl.controls; let i=index; trackBy: trackById"
                   [formControl]="control"
                   [formControlName]="i"
                   (edited)="onEdit()"
                   (crossClick)="onRemove($event)"
                   data-ideals="chip">
      </ideals-chip>

      <input class="ideals-chips-input"
             autocomplete="off"
             type="text"
             [attr.data-chip-editor]="componentId"
             [placeholder]="currentPlaceholder"
             (blur)="onBlur($event)"
             (keydown)="onKeydown($event)"
             (paste)="paste($event)"
             data-ideals="newUserEmail"/>
    </div>
  </ideals-input-control-wrapper>
</div>
